import { validateCoordinatePair } from '../pages/Boletim/Header/coordinateValidation';

// Shared by autosave and explicit save: drafts may be incomplete locally, but
// a new report must never reach the API without valid occurrence coordinates.
export function validateBoletim(report) {
  const errors = {};
  if (typeof report.numero !== 'string' || !report.numero.trim()) errors.numero = 'Número: informe a identificação do boletim.';
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(report.data || '');
  const date = match && new Date(Date.UTC(+match[3], +match[2] - 1, +match[1]));
  if (!match || date.getUTCFullYear() !== +match[3] || date.getUTCMonth() !== +match[2] - 1 || date.getUTCDate() !== +match[1]) {
    errors.data = 'Data: informe uma data válida no formato DD/MM/AAAA.';
  }
  if (typeof report.municipio !== 'string' || !report.municipio.trim()) errors.municipio = 'Município: informe o município da ocorrência.';
  if (!report._id && !(report.naturezaIds || []).length && !report.naturezaId) errors.natureza = 'Natureza: selecione uma natureza oficial.';
  if (report.horario && !/^([01]\d|2[0-3]):[0-5]\d$/.test(report.horario)) errors.horario = 'Horário: informe uma hora válida (HH:mm).';
  Object.assign(errors, validateCoordinatePair(report.latitude, report.longitude).errors);
  return errors;
}

export function boletimValidationError(report) {
  const errors = validateBoletim(report);
  if (!Object.keys(errors).length) return null;
  const error = new Error(`Não foi possível salvar o boletim. Corrija os seguintes campos:\n${Object.values(errors).join('\n')}`);
  error.fields = errors;
  return error;
}
